import React, {useState} from 'react';
import './DanhMucLinhVuc.css';

function DanhMucLinhVuc () {

    const [showPage, setShowPage] = useState(false)
     const [addDanhMuc, setAddDanhMuc] = useState("add-danh-muc");


    // hàm mở page
    const openPageAdd = () => {
        setShowPage(true);
        setAddDanhMuc("add-danh-muc")
    }

    //hàm đóng page
    const cancelPageAdd = () => {
        setShowPage(false)
    }
  
        return (
            <div>

      {/* { Header } */}
    <div className="danh-muc-linh-vuc-wrapper">

        <div className="danh-muc-linh-vuc-title">
            <h2>Danh mục lĩnh vực</h2>
        </div>

        <div className="danh-muc-linh-vuc-breadcrumb">
            <span>Trang chủ</span>
            <span>/</span>
            <span>Quản lý lĩnh vực ngành</span>
            <span>/</span>
            <span>Danh mục lĩnh vực</span>
        </div>

        {/* { Bộ lọc } */}
        <div className="danh-muc-linh-vuc-filter">

            <div className="danh-muc-linh-vuc-filter-left">

                <div className="danh-muc-linh-vuc-search">
                    <input
                        type="text"
                        placeholder="Tìm kiếm theo mã, tên lĩnh vực..."
                    />
                    <i class="fa-solid fa-magnifying-glass"></i>
                </div>

                <div className='danh-muc-lv-choose'>

                <div className="danh-muc-linh-vuc-select-box">
                    <label>Nhóm lĩnh vực</label>
                    <select>
                        <option>Tất cả</option>
                    </select>
                </div>

                <div className="danh-muc-linh-vuc-select-box">
                    <label>Trạng thái</label>
                    <select>
                        <option>Tất cả</option>
                    </select>
                </div>
                </div>


            </div>

            <div className="danh-muc-linh-vuc-filter-right">

                <button className="danh-muc-linh-vuc-btn-import">
                    {/* <i class="fa-solid fa-file-import"></i> */}
                    <i className="fa-solid fa-download"></i>
                    Nhập dữ liệu
                </button>

                <button className="danh-muc-linh-vuc-btn-export">
                    {/* <i class="fa-solid fa-file-export"></i> */}
                    <i className="fa-solid fa-arrow-up-from-bracket"></i>
                    Xuất dữ liệu
                </button>

                <button className="danh-muc-linh-vuc-btn-add" onClick={openPageAdd}>
                    <i class="fa-solid fa-plus"></i>
                    Thêm lĩnh vực
                </button>

            </div>

        </div>

        {/* { Bảng dữ liệu } */}
        <div className="danh-muc-linh-vuc-table-wrapper">

            <table className="danh-muc-linh-vuc-table">

                <thead>
                    <tr>
                        <th>
                            <input type="checkbox" />
                        </th>
                        <th>STT</th>
                        <th>Mã lĩnh vực</th>

                        <th>
                            <div className="danh-muc-linh-vuc-sort-title">
                                <span>Tên lĩnh vực</span>
                                <i class="fa-solid fa-arrow-down-wide-short"></i>
                            </div>
                        </th>

                        <th>Nhóm lĩnh vực</th>

                        <th>Mô tả</th>

                        <th>Trạng thái</th>

                        <th>
                            <div className="danh-muc-linh-vuc-sort-title">
                                <span>Thứ tự</span>
                                <i class="fa-solid fa-arrow-down-wide-short"></i>
                            </div>
                        </th>

                        <th>Ngày tạo</th>
                        <th>Thao tác</th>
                    </tr>
                </thead>

                <tbody>

                    <tr>
                        <td><input type="checkbox" /></td>
                        <td>1</td>
                        <td className='lv-share'>LV001</td>
                        <td>Công nghiệp</td>
                        <td>Sản xuất công nghiệp</td>
                        <td>Quản lý các hoạt động sản xuất công nghiệp</td>
                        <td>
                            <span className="danh-muc-linh-vuc-status-active">
                                Hoạt động
                            </span>
                        </td>
                        <td className='sort-name'>1</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="danh-muc-linh-vuc-action">
                                <button><i class="fa-regular fa-pen-to-square"></i></button>
                                <button><i class="fa-regular fa-eye"></i></button>
                                <button><i class="fa-regular fa-trash-can"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><input type="checkbox" /></td>
                        <td>2</td>
                        <td className='lv-share'>LV002</td>
                        <td>Thương mại</td>
                        <td>Thương mại - Dịch vụ</td>
                        <td>Quản lý hoạt động thương mại và dịch vụ</td>
                        <td>
                            <span className="danh-muc-linh-vuc-status-active">
                                Hoạt động
                            </span>
                        </td>
                        <td  className='sort-name'>2</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="danh-muc-linh-vuc-action">
                                <button><i class="fa-regular fa-pen-to-square"></i></button>
                                <button><i class="fa-regular fa-eye"></i></button>
                                <button><i class="fa-regular fa-trash-can"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><input type="checkbox" /></td>
                        <td >3</td>
                        <td className='lv-share'>LV003</td>
                        <td>Điện lực</td>
                        <td>Điện lực - Năng lượng</td>
                        <td>Quản lý hệ thống điện và cung cấp điện</td>
                        <td>
                            <span className="danh-muc-linh-vuc-status-active">
                                Hoạt động
                            </span>
                        </td>
                        <td  className='sort-name'>3</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="danh-muc-linh-vuc-action">
                                <button><i class="fa-regular fa-pen-to-square"></i></button>
                                <button><i class="fa-regular fa-eye"></i></button>
                                <button><i class="fa-regular fa-trash-can"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><input type="checkbox" /></td>
                        <td >4</td>
                        <td className='lv-share'>LV004</td>
                        <td>Năng lượng</td>
                        <td>Điện lực - Năng lượng</td>
                        <td>Quản lý năng lượng và sử dụng năng lượng</td>
                        <td>
                            <span className="danh-muc-linh-vuc-status-active">
                                Hoạt động
                            </span>
                        </td>
                        <td  className='sort-name'>4</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="danh-muc-linh-vuc-action">
                                <button><i class="fa-regular fa-pen-to-square"></i></button>
                                <button><i class="fa-regular fa-eye"></i></button>
                                <button><i class="fa-regular fa-trash-can"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><input type="checkbox" /></td>
                        <td >5</td>
                        <td className='lv-share'>LV005</td>
                        <td>Xuất nhập khẩu</td>
                        <td>Thương mại - Dịch vụ</td>
                        <td>Quản lý hoạt động xuất nhập khẩu hàng hóa</td>
                        <td>
                            <span className="danh-muc-linh-vuc-status-active">
                                Hoạt động
                            </span>
                        </td>
                        <td  className='sort-name'>5</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="danh-muc-linh-vuc-action">
                                <button><i class="fa-regular fa-pen-to-square"></i></button>
                                <button><i class="fa-regular fa-eye"></i></button>
                                <button><i class="fa-regular fa-trash-can"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><input type="checkbox" /></td>
                        <td >6</td>
                        <td className='lv-share'>LV006</td>
                        <td>Thị trường trong nước</td>
                        <td>Thương mại - Dịch vụ</td>
                        <td>Quản lý thị trường trong nước và giá cả</td>
                        <td>
                            <span className="danh-muc-linh-vuc-status-active">
                                Hoạt động
                            </span>
                        </td>
                        <td  className='sort-name'>6</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="danh-muc-linh-vuc-action">
                                <button><i class="fa-regular fa-pen-to-square"></i></button>
                                <button><i class="fa-regular fa-eye"></i></button>
                                <button><i class="fa-regular fa-trash-can"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><input type="checkbox" /></td>
                        <td >7</td>
                        <td className='lv-share'>LV007</td>
                        <td>Khuyến công</td>
                        <td>Hỗ trợ doanh nghiệp</td>
                        <td>Quản lý hoạt động khuyến công và hỗ trợ DN</td>
                        <td>
                            <span className="danh-muc-linh-vuc-status-active">
                                Hoạt động
                            </span>
                        </td>
                        <td  className='sort-name'>7</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="danh-muc-linh-vuc-action">
                                <button><i class="fa-regular fa-pen-to-square"></i></button>
                                <button><i class="fa-regular fa-eye"></i></button>
                                <button><i class="fa-regular fa-trash-can"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><input type="checkbox" /></td>
                        <td >8</td>
                        <td className='lv-share'>LV008</td>
                        <td>An toàn thực phẩm</td>
                        <td>An toàn thực phẩm</td>
                        <td>Quản lý an toàn thực phẩm thuộc ngành</td>
                        <td>
                            <span className="danh-muc-linh-vuc-status-pause">
                                Tạm dừng
                            </span>
                        </td>
                        <td  className='sort-name'>8</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="danh-muc-linh-vuc-action">
                                <button><i class="fa-regular fa-pen-to-square"></i></button>
                                <button><i class="fa-regular fa-eye"></i></button>
                                <button><i class="fa-regular fa-trash-can"></i></button>
                            </div>
                        </td>
                    </tr>

                </tbody>

            </table>

        </div>

        {/* { Footer } */}
        <div className="danh-muc-linh-vuc-footer">

            <div className="danh-muc-linh-vuc-total">
                Hiển thị 1 đến 8 trong tổng số 8 bản ghi
            </div>

            <div className="danh-muc-linh-vuc-pagination">

                <select>
                    <option>10</option>
                </select>

                <button>
                    <i class="fa-solid fa-chevron-left"></i>
                </button>

                <button className="danh-muc-linh-vuc-page-active">
                    1
                </button>

                <button>
                    <i class="fa-solid fa-chevron-right"></i>
                </button>

            </div>

        </div>

    </div>

            

            {
                showPage && (
                    <div
                     className={
                    addDanhMuc === "add-danh-muc"
                        ? "danh-muc-linh-vuc-open-page-add-show"
                        : "danh-muc-linh-vuc-open-page-add-hide"
                }
                    >

 <div className="">

    {/* Header */}
    <div className="add-danh-muc-linh-vuc-wrapper">

        <div className="add-danh-muc-linh-vuc-header">
            <h2 className="add-danh-muc-linh-vuc-title">
                Thêm danh mục lĩnh vực
            </h2>

            <div className="add-danh-muc-linh-vuc-breadcrumb">
                <span>Trang chủ</span>
                <span>/</span>
                <span>Quản lý lĩnh vực ngành</span>
                <span>/</span>
                <span>Danh mục lĩnh vực</span>
                <span>/</span>
                <span>Thêm danh mục lĩnh vực</span>
            </div>
        </div>

        <div className="add-danh-muc-linh-vuc-content">

            <div className="add-danh-muc-linh-vuc-form-grid">

                {/* Cột trái */}
                <div className="add-danh-muc-linh-vuc-left">

                    <h4 className="add-danh-muc-linh-vuc-section-title">
                        Thông tin danh mục lĩnh vực
                    </h4>

                    <div className="add-danh-muc-linh-vuc-field">
                        <label className="add-danh-muc-linh-vuc-label">
                            Mã lĩnh vực <span>*</span>
                        </label>

                        <div className="add-danh-muc-linh-vuc-input-wrap">
                            <input
                                type="text"
                                className="add-danh-muc-linh-vuc-input-ma"
                                placeholder="Nhập mã lĩnh vực"
                            />

                            <small className="add-danh-muc-linh-vuc-note">
                                Mã viết tắt, không trùng với mã lĩnh vực khác (VD: LV001)
                            </small>
                        </div>
                    </div>

                    <div className="add-danh-muc-linh-vuc-field">
                        <label className="add-danh-muc-linh-vuc-label">
                            Tên lĩnh vực <span>*</span>
                        </label>

                        <input
                            type="text"
                            className="add-danh-muc-linh-vuc-input-ten"
                            placeholder="Nhập tên lĩnh vực"
                        />
                    </div>

                    <div className="add-danh-muc-linh-vuc-field">
                        <label className="add-danh-muc-linh-vuc-label">
                            Nhóm lĩnh vực <span>*</span>
                        </label>

                        <div className="add-danh-muc-linh-vuc-select-wrap">
                            <select className="add-danh-muc-linh-vuc-select-nhom">
                                <option>-- Chọn nhóm lĩnh vực --</option>
                            </select>

                            {/* <i className="fa-solid fa-chevron-down add-danh-muc-linh-vuc-select-icon"></i> */}
                        </div>
                    </div>

                    <div className="add-danh-muc-linh-vuc-field">
                        <label className="add-danh-muc-linh-vuc-label">
                            Mô tả
                        </label>

                        <div className="add-danh-muc-linh-vuc-textarea-wrap">
                            <textarea
                                className="add-danh-muc-linh-vuc-textarea-mo-ta"
                                placeholder="Nhập mô tả lĩnh vực"
                            ></textarea>

                            <span className="add-danh-muc-linh-vuc-counter-left">
                                0/500
                            </span>
                        </div>
                    </div>

                </div>

                {/* Cột phải */}
                <div className="add-danh-muc-linh-vuc-right">

                    <h4 className="add-danh-muc-linh-vuc-section-title-right">
                        Thông tin bổ sung
                    </h4>

                    <div className="add-danh-muc-linh-vuc-field-right">
                        <label className="add-danh-muc-linh-vuc-label-right">
                            Đơn vị quản lý <span>*</span>
                        </label>

                        <div className="add-danh-muc-linh-vuc-select-wrap-right">
                            <select className="add-danh-muc-linh-vuc-select-don-vi">
                                <option>-- Chọn đơn vị quản lý --</option>
                            </select>

                            {/* <i className="fa-solid fa-chevron-down add-danh-muc-linh-vuc-select-icon-right"></i> */}
                        </div>
                    </div>

                    <div className="add-danh-muc-linh-vuc-field-right">
                        <label className="add-danh-muc-linh-vuc-label-right">
                            Thứ tự hiển thị <span>*</span>
                        </label>

                        <div className="add-danh-muc-linh-vuc-order-wrap">
                            <input
                                type="number"
                                className="add-danh-muc-linh-vuc-order-input"
                                defaultValue="0"
                            />

                            <small className="add-danh-muc-linh-vuc-order-note">
                                Số thứ tự càng nhỏ hiển thị càng lên đầu
                            </small>
                        </div>
                    </div>

                    <div className="add-danh-muc-linh-vuc-field-right">
                        <label className="add-danh-muc-linh-vuc-label-right">
                            Trạng thái <span>*</span>
                        </label>

                        <div className="add-danh-muc-linh-vuc-radio-group">

                            <label className="add-danh-muc-linh-vuc-radio-item">
                                <input
                                    type="radio"
                                    name="status"
                                    defaultChecked
                                />
                                Hoạt động
                            </label>

                            <label className="add-danh-muc-linh-vuc-radio-item">
                                <input
                                    type="radio"
                                    name="status"
                                />
                                Tạm dừng
                            </label>

                        </div>
                    </div>

                    <div className="add-danh-muc-linh-vuc-field-right">
                        <label className="add-danh-muc-linh-vuc-label-right">
                            Ghi chú
                        </label>

                        <div className="add-danh-muc-linh-vuc-textarea-wrap-right">
                            <textarea
                                className="add-danh-muc-linh-vuc-textarea-note"
                                placeholder="Nhập ghi chú (nếu có)"
                            ></textarea>

                            <span className="add-danh-muc-linh-vuc-counter-right">
                                0/255
                            </span>
                        </div>
                    </div>

                </div>

            </div>

            {/* Hướng dẫn */}
            <div className="add-danh-muc-linh-vuc-guide-box">

                <div className="add-danh-muc-linh-vuc-guide-title">
                    <i className="fa-solid fa-circle-info"></i>
                    Hướng dẫn
                </div>

                <ul className="add-danh-muc-linh-vuc-guide-list">
                    <li>Mã lĩnh vực là duy nhất và không thể thay đổi sau khi tạo.</li>
                    <li>Vui lòng chọn đúng nhóm lĩnh vực để dễ dàng quản lý và phân loại.</li>
                    <li>Trạng thái "Tạm dừng" sẽ ẩn lĩnh vực khỏi danh sách sử dụng.</li>
                </ul>

            </div>

            {/* Footer */}
            <div className="add-danh-muc-linh-vuc-footer">

                <button className="add-danh-muc-linh-vuc-back-btn" onClick={cancelPageAdd}>
                    <i className="fa-solid fa-arrow-left"></i>
                    Quay lại danh sách
                </button>

                <div className="add-danh-muc-linh-vuc-action-group">

                    <button className="add-danh-muc-linh-vuc-cancel-btn" onClick={cancelPageAdd}>
                        Hủy bỏ
                    </button>

                    <button className="add-danh-muc-linh-vuc-save-new-btn">
                        <i className="fa-regular fa-floppy-disk"></i>
                        Lưu và thêm mới
                    </button>

                    <button className="add-danh-muc-linh-vuc-save-btn">
                        <i className="fa-regular fa-floppy-disk"></i>
                        Lưu
                    </button>

                </div>

            </div>

        </div>

    </div>

</div>

                    </div>


                )
            }
            </div>
        );
    }


export default DanhMucLinhVuc;